import { render, staticRenderFns } from "./infoRegularRepair.vue?vue&type=template&id=32572ac6&scoped=true&"
import script from "./infoRegularRepair.vue?vue&type=script&lang=js&"
export * from "./infoRegularRepair.vue?vue&type=script&lang=js&"
import style0 from "./infoRegularRepair.vue?vue&type=style&index=0&id=32572ac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32572ac6",
  null
  
)

export default component.exports